import React from 'react'

function AddTransactions() {
  return (
    <div>AddTransactions</div>
  )
}

export default AddTransactions